export default "__VITE_ASSET__j7s3s5gO__"